function support(){
	var validator = new FormValidator('support-form', [
		{
			name: 'name',
			display:'name',
			rules:'required'
		},
		{
			name:'email',
			display:'email',
			rules:'required|valid_email'
		},
		{
			name:'domain',
			display:'domain',
			rules:'required'
		},
		{
			name:'cell',
			display:'cell',
			rules:'required|numeric'
		},
		{
			name:'description',
			display:'description',
			rules:'required'
		},
	], POP.form.validator.errorHandler.bind(POP.form.validator))

	$(function(){
		$('input, textarea').on('keyup', function(e){
			var $el = $(e.target), inputStripped = $el.val().replace(/\s/g,'');

			if(inputStripped.length > 0){
				$el.removeClass('invalid');
			}
			return true;
		});
		$('[name=support-form] button[type=submit]').on('click', function(){
			POP.Ajax.submitting($('button[type=submit]', this));
		})
	});
}